import { render } from "./ValidationPreInscriptionsList.vue?vue&type=template&id=66f45d3a&scoped=true"
import script from "./ValidationPreInscriptionsList.vue?vue&type=script&lang=js"
export * from "./ValidationPreInscriptionsList.vue?vue&type=script&lang=js"

import "./ValidationPreInscriptionsList.vue?vue&type=style&index=0&id=66f45d3a&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f45d3a"]])

export default __exports__